import router from './router'
// import { setShare } from './share'
// import wechatAuth from '@/utils/wechatAuth' // 微信登录插件
import { getUrlKey } from '@/utils/index' // 获取url参数
// import { getLogin, setLogin, setLock, getLock, outLock } from '@/utils/auth' // 获取url参数
// import { visit, baidu, zhihu, bilibili } from '@/api/statistics'
router.beforeEach((to, from, next) => {
  window.location.href = 'https://front.crm.yes-go.cn/frontend-h5/dist/activity.html?' +
  'activityId=' + getUrlKey('activityId') +
  (getUrlKey('income') ? '&income=' + getUrlKey('income') : '') +
  (getUrlKey('inviter') ? '&inviter=' + getUrlKey('inviter') : '') +
  (getUrlKey('inviterId') ? '&inviterId=' + getUrlKey('inviterId') : '') +
  (getUrlKey('paymentCode') ? '&paymentCode=' + getUrlKey('paymentCode') : '')
  // var activityId = getUrlKey('activityId') // 活动ID
  // var income = getUrlKey('income') // 渠道ID
  // var inviter = getUrlKey('inviter') // 邀请人
  // var inviterId = getUrlKey('inviterId') // 邀请人openid
  // var channel = getUrlKey('channel') // 投放平台
  // baidu() // 百度代码统计
  // // 判断是否微信环境
  // if (checkWx()) {
  //   var urlOpenId = getUrlKey('openid')
  //   var wxKey = getUrlKey('WxKey')
  //   const url = window.location.host + window.location.pathname
  //   if (getLogin()) {
  //     // 有openid，进入主页
  //     visit(activityId + '号活动' + to.meta.title + '页', activityId)
  //     // 分享WX
  //     setShare({ activityId: activityId, wxKey: wxKey, income: income, inviter: inviter, inviterId: inviterId })
  //     next()
  //   } else {
  //     if (urlOpenId && getLock()) {
  //       setLogin(urlOpenId)
  //       outLock() // 解锁
  //       visit(activityId + '号活动' + to.meta.title + '页', activityId)
  //       // 分享WX
  //       setShare({ activityId: activityId, wxKey: wxKey, income: income, inviter: inviter, inviterId: inviterId })
  //       next()
  //     } else {
  //       setLock() // 没有openid,设置setLock加锁
  //       wechatAuth.redirect_url = url
  //       wechatAuth.parameter = 'WxKey=' + wxKey + '&activityId=' + activityId + '&income=' + income + '&inviter=' + inviter + '&inviterId=' + inviterId
  //       window.location.href = wechatAuth.authUrl
  //     }
  //   }
  // } else {
  //   if (channel === 'zhihu') {
  //     console.log(channel)
  //     zhihu()
  //   }
  //   if (channel === 'bilibili') {
  //     console.log(channel)
  //     bilibili()
  //   }
  //   visit(activityId + '号活动' + to.meta.title + '页', activityId)
  //   next()
  // }
})

